import React, { Component } from "react";
import { FaDownload } from "react-icons/fa";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Link } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";
import Select from "react-select";
import { getdistrictlist } from "store/participantdistrict/actions";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  Table,
} from "reactstrap";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import filterFactory from "react-bootstrap-table2-filter";
import Breadcrumbs from "components/Common/Breadcrumb";
import { getanalytereport2 } from "store/Payment/actions";
import { getAnalytelist } from "store/databaseofunits/actions";
import "assets/scss/table.scss";
import { Formik, Field, Form, ErrorMessage } from "formik";

class AnalyteReport2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      nameFilter: "",
      idFilter: "",
      districtFilter: "",
      resultFilter: "",
      resulttypeFilter: "",
      roundNameFilter: "",
      unitFilter: "",
      methodFilter: "",
      instrumentFilter: "",
      reagentFilter: "",
      participantFilter: "",
      schemeFilter: "",
      schemeModalOpen: false,
      amountFilter: "",
      discountFilter: "",
      GetAnalyte: [],
      tableKey: 0,
      feedbackMessage: "",
      totalParticipants: "",
      participantsWithResults: "",
      analyteType: "",
      errorMessage: "",
      editModalOpen: false,
      selectedRow: null,
      analytes: [], // ✅ initialize
      schemes: [], // ✅ initialize
      cycles: [], // ✅ initialize
      rounds: [],
      filteredSchemes: [],
      filteredCycles: [],
      filteredRounds: [],
      analyteFilter: "",
      schemeFilter: "",
      cycleFilter: "",
      roundFilter: "", // ✅ initialize
      ListDistrict: [], // ✅ initialize
      user_id: localStorage.getItem("authUser")
        ? JSON.parse(localStorage.getItem("authUser")).user_id
        : "",
      feedbackListColumns: [
        {
          dataField: "district",
          text: "District",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.districtFilter}
                  onChange={e => this.handleFilterChange("districtFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "lab_name",
          text: "Participant",
          sort: true,
          style: { textAlign: "left" },
          formatter: (cell, row) => (
            <span
              style={{
                color: "blue",
                cursor: "pointer",
              }}
              onClick={() => this.openParticipantModal(row)}
            >
              {cell || "NS"}
            </span>
          ),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.participantFilter}
                  onChange={e =>
                    this.handleFilterChange("participantFilter", e)
                  }
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "result_value",
          text: "Result",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell =>
            cell !== null && cell !== undefined ? cell : "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.resultFilter}
                  onChange={e => this.handleFilterChange("resultFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "result_type",
          text: "Result Type",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell =>
            cell !== null && cell !== undefined ? cell : "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.resulttypeFilter}
                  onChange={e => this.handleFilterChange("resulttypeFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "round_name",
          text: "Round",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell =>
            cell !== null && cell !== undefined ? cell : "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.roundNameFilter}
                  onChange={e => this.handleFilterChange("roundNameFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "unit", // ✅ matches API
          text: "Unit",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.unitFilter}
                  onChange={e => this.handleFilterChange("unitFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "instrument", // ✅ matches API
          text: "Instrument",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.instrumentFilter}
                  onChange={e => this.handleFilterChange("instrumentFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "method", // ✅ matches API
          text: "Method",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.methodFilter}
                  onChange={e => this.handleFilterChange("methodFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
        {
          dataField: "reagent", // ✅ matches API
          text: "Reagent",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => cell || "NS",
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.reagentFilter}
                  onChange={e => this.handleFilterChange("reagentFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "120px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        },
      ],
    };
  }
  componentDidMount() {
    const { onGetAnalyte } = this.props;
    const { user_id } = this.state;

    if (user_id) {
      onGetAnalyte(user_id);
    }
  }

  fetchData() {
    const { onGetAnalyteReport2 } = this.props;
    const { analyteFilter } = this.state;

    if (analyteFilter) {
      // analyteFilter must be analyte_id, not name
      onGetAnalyteReport2(analyteFilter);
    }
  }
  componentDidUpdate(prevProps) {
    // Update analytes dropdown when list changes
    if (this.props.AnalyteList !== prevProps.AnalyteList) {
      const analytes = Array.isArray(this.props.AnalyteList)
        ? this.props.AnalyteList
        : [];
      console.log("Fetched analytes:", analytes); // For debugging
      this.setState({ analytes });
    }

    // Update table data when AnalyteReport2 changes
    if (this.props.AnalyteReport2 !== prevProps.AnalyteReport2) {
      const analyte = this.props.AnalyteReport2?.analyte || {};
      const schemes = this.props.AnalyteReport2?.schemes || [];

      const flatLabs = [];

      schemes.forEach(scheme => {
        (scheme.cycles || []).forEach(cycle => {
          if (Array.isArray(cycle.rounds) && cycle.rounds.length > 0) {
            // Normal handling of rounds
            cycle.rounds.forEach(round => {
              if (Array.isArray(round.labs) && round.labs.length > 0) {
                round.labs.forEach(lab => {
                  flatLabs.push({
                    scheme_id: scheme.scheme_id,
                    scheme_name: scheme.scheme_name,
                    cycle_no: cycle.cycle_no,
                    round_id: round.round_id,
                    round_name: round.round_name,
                    round_status: round.status,
                    lab_id: lab.lab_id,
                    lab_name: lab.lab_name,
                    province: lab.province,
                    district: lab.district,
                    city: lab.city,
                    unit: lab.unit,
                    instrument: lab.instrument,
                    method: lab.method,
                    reagent: lab.reagent,
                    analytetype: analyte?.type || "",
                    result_value: lab.result_value,
                    result_type: lab.result_type,
                    analyte_id: analyte?.id || this.state.analyteFilter,
                    analyte_name: analyte?.name || "",
                  });
                });
              } else {
                flatLabs.push({
                  scheme_id: scheme.scheme_id,
                  scheme_name: scheme.scheme_name,
                  cycle_no: cycle.cycle_no,
                  round_id: round.round_id,
                  round_name: round.round_name,
                  round_status: round.status,
                  lab_id: null,
                  lab_name: "No Participant",
                  province: "",
                  district: "",
                  city: "",
                  unit: "",
                  instrument: "",
                  method: "",
                  reagent: "",
                  result_type: "",
                  result_value: null,
                  analyte_id: analyte?.id || this.state.analyteFilter,
                  analyte_name: analyte?.name || "",
                });
              }
            });
          } else if (
            Array.isArray(cycle.paid_participants) &&
            cycle.paid_participants.length > 0
          ) {
            // NEW: handle cycles without rounds
            cycle.paid_participants.forEach(lab => {
              flatLabs.push({
                scheme_id: scheme.scheme_id,
                scheme_name: scheme.scheme_name,
                cycle_no: cycle.cycle_no,
                round_id: null,
                round_name: null,
                round_status: null,
                lab_id: lab.lab_id,
                lab_name: lab.lab_name,
                province: "",
                district: "",
                city: "",
                unit: "",
                instrument: "",
                method: "",
                reagent: "",
                result_type: "",
                result_value: null,
                analyte_id: analyte?.id || this.state.analyteFilter,
                analyte_name: analyte?.name || "",
              });
            });
          } else {
            // No rounds and no participants → show placeholder
            flatLabs.push({
              scheme_id: scheme.scheme_id,
              scheme_name: scheme.scheme_name,
              cycle_no: cycle.cycle_no,
              round_id: null,
              round_name: null,
              round_status: null,
              lab_id: null,
              lab_name: "No Participant",
              province: "",
              district: "",
              city: "",
              unit: "",
              instrument: "",
              method: "",
              reagent: "",
              result_type: "",
              result_value: null,
              analyte_id: analyte?.id || this.state.analyteFilter,
              analyte_name: analyte?.name || "",
            });
          }
        });
      });

      this.setState({
        reportAnalyte: analyte,
        reportSchemes: schemes,
        analyteType: schemes?.[0]?.analytetype || "",
        GetAnalyte: flatLabs,
        filteredSchemes: schemes.map(s => s.scheme_name),
        filteredCycles: [],
        filteredRounds: [],
        schemeFilter: "",
        cycleFilter: "",
        roundFilter: "",
      });
    }
  }

  getTotalParticipants() {
    const data = this.filterData(); // already filtered
    const uniqueParticipants = new Set();
    const submittedParticipants = new Set();

    (data || []).forEach(e => {
      if (e.lab_id) {
        const key = `${e.scheme_id}-${e.cycle_no}-${e.lab_id}`;
        uniqueParticipants.add(key);
        if (e.result_value !== null && e.result_value !== undefined) {
          submittedParticipants.add(key);
        }
      }
    });

    return {
      total: uniqueParticipants.size,
      submitted: submittedParticipants.size,
    };
  }

  openParticipantModal = row => {
    const { GetAnalyte } = this.state;

    // find all rounds for this participant (lab_id + analyte_id + scheme/cycle)
    const labRounds = (GetAnalyte || []).filter(
      entry =>
        entry.lab_id === row.lab_id &&
        entry.analyte_id === row.analyte_id &&
        entry.scheme_name === row.scheme_name &&
        String(entry.cycle_no) === String(row.cycle_no)
    );

    if (!labRounds.length) {
      console.error("❌ No matching lab rounds found for row:", row);
      return;
    }

    // build participant row
    const participantRow = {
      Analyte: row.analyte_name,
      Scheme: row.scheme_name,
      Cycle: row.cycle_no,
    };

    labRounds.forEach((r, idx) => {
      participantRow[`R ${idx + 1}`] = r.instrument || "NS";
    });

    this.setState({
      participantModalOpen: true,
      selectedParticipant: row.lab_name,
      participantRows: [participantRow], // store as array
    });
  };
  handleSchemeChange = selected => {
    const selectedSchemeName = selected?.value === "All" ? "" : selected?.value;
    this.setState({
      schemeFilter: selectedSchemeName,
      cycleFilter: "",
      roundFilter: "",
      filteredRounds: [],
    });

    const selectedScheme = (this.state.reportSchemes || []).find(
      s => s.scheme_name === selectedSchemeName
    );

    let cycles = [];
    if (selectedScheme && Array.isArray(selectedScheme.cycles)) {
      cycles = selectedScheme.cycles.map(c => c.cycle_no);
    }

    this.setState({
      filteredCycles: [...new Set(cycles)],
    });
  };

  handleAnalyteChange = selected => {
    const selectedAnalyteId = selected?.value === "All" ? "" : selected?.value;

    this.setState({
      analyteFilter: selectedAnalyteId,
      schemeFilter: "",
      cycleFilter: "",
      roundFilter: "",
      filteredCycles: [],
      filteredRounds: [],
      GetAnalyte: [],
    });

    if (selectedAnalyteId) {
      const user_id = this.state.user_id;
      this.props.onGetAnalyteReport2(selectedAnalyteId, user_id);
    }
  };

  handleCycleChange = selected => {
    const selectedCycle = selected?.value === "All" ? "" : selected?.value;
    const { schemeFilter, reportSchemes } = this.state;

    const selectedScheme = (reportSchemes || []).find(
      s => s.scheme_name === schemeFilter
    );

    let roundsForCycle = [];

    if (selectedScheme && Array.isArray(selectedScheme.cycles)) {
      const cycleObj = selectedScheme.cycles.find(
        c => String(c.cycle_no) === String(selectedCycle)
      );

      if (cycleObj && Array.isArray(cycleObj.rounds)) {
        roundsForCycle = cycleObj.rounds.map(r => ({
          round_id: r.round_id,
          round_name: r.round_name,
        }));
      }
    }

    this.setState({
      cycleFilter: selectedCycle,
      roundFilter: "",
      filteredRounds: roundsForCycle,
    });
  };

  handleRoundChange = selected => {
    const selectedRound = selected?.value === "All" ? "" : selected?.value;
    this.setState({
      roundFilter: selectedRound,
      currentPage: 1,
    });
  };

  handleSchemeModalClose = () => {
    this.setState({
      schemeModalOpen: false,
    });
  };

  handleMouseExit = () => {
    this.setState({
      PatientModal: false,
      MarketerModal: false,
      LabModal: false,
      isHovered: false,
    });
  };
  handleFilterChange = (filterName, e) => {
    const value = e.target.value;
    this.setState({
      [filterName]: value,
      currentPage: 1, // ✅ reset pagination to first page when filter changes
    });
  };

  handleFileChange = (event, setFieldValue) => {
    const file = event.currentTarget.files[0];
    setFieldValue("photo", file);
  };
  filterData = () => {
    const {
      GetAnalyte,
      analyteFilter,
      schemeFilter,
      cycleFilter,
      roundFilter,
      districtFilter,
      unitFilter,
      resultFilter,
      resulttypeFilter,
      roundNameFilter,
      methodFilter,
      instrumentFilter,
      reagentFilter,
      participantFilter,
    } = this.state;

    if (!Array.isArray(GetAnalyte) || GetAnalyte.length === 0) return [];

    return GetAnalyte.filter(entry => {
      return (
        (!analyteFilter ||
          String(entry.analyte_id) === String(analyteFilter)) &&
        (!schemeFilter ||
          (entry.scheme_name || "")
            .toLowerCase()
            .includes(schemeFilter.toLowerCase())) &&
        (!cycleFilter || String(entry.cycle_no) === String(cycleFilter)) &&
        (!roundFilter || String(entry.round_id) === String(roundFilter)) &&
        (!districtFilter ||
          (entry.district || "")
            .toLowerCase()
            .includes(districtFilter.toLowerCase())) &&
        (!unitFilter ||
          (entry.unit || "")
            .toLowerCase()
            .includes(unitFilter.toLowerCase())) &&
        (!resultFilter ||
          (entry.result_value !== null && entry.result_value !== undefined
            ? String(entry.result_value)
                .toLowerCase()
                .includes(resultFilter.toLowerCase())
            : false)) &&
        (!resulttypeFilter ||
          (entry.result_type !== null && entry.result_type !== undefined
            ? String(entry.result_type)
                .toLowerCase()
                .includes(resulttypeFilter.toLowerCase())
            : false)) &&
        (!roundNameFilter ||
          (entry.round_name || "")
            .toLowerCase()
            .includes(roundNameFilter.toLowerCase())) &&
        (!methodFilter ||
          (entry.method || "")
            .toLowerCase()
            .includes(methodFilter.toLowerCase())) &&
        (!instrumentFilter ||
          (entry.instrument || "")
            .toLowerCase()
            .includes(instrumentFilter.toLowerCase())) &&
        (!reagentFilter ||
          (entry.reagent || "")
            .toLowerCase()
            .includes(reagentFilter.toLowerCase())) &&
        (!participantFilter ||
          (entry.lab_name || "")
            .toLowerCase()
            .includes(participantFilter.toLowerCase()))
      );
    });
  };

  getUniqueOptions = fieldName => {
    // Always use full data, not filtered
    const allData = this.state.GetAnalyte || [];
    const options = new Set();

    allData.forEach(item => {
      const value = item[fieldName];
      if (Array.isArray(value)) {
        value.forEach(v => options.add(v));
      } else if (value) {
        options.add(value);
      }
    });

    return Array.from(options);
  };

  checkFiltersApplied = () => {
    const {
      nameFilter,
      idFilter,
      districtFilter,
      unitFilter,
      resultFilter,
      resulttypeFilter,
      roundNameFilter,
      methodFilter,
      instrumentFilter,
      reagentFilter,
      participantFilter,
      schemeFilter,
      schemepriceFilter,
    } = this.state;

    // Check if ANY filter is applied AND has a NON-EMPTY value
    const filters = [
      nameFilter,
      idFilter,
      districtFilter,
      unitFilter,
      methodFilter,
      resultFilter,
      resulttypeFilter,
      roundNameFilter,
      instrumentFilter,
      reagentFilter,
      participantFilter,
      schemeFilter,
      schemepriceFilter,
    ];

    const anyFilterSelected = filters.some(f => f && f.trim() !== "");

    this.setState({ filtersApplied: anyFilterSelected });
  };

  render() {
    const { GetAnalyte } = this.state;
    const { onGetAnalyte } = this.props;
    const defaultSorted = [{ dataField: "id", order: "desc" }];
    const { ListDistrict } = this.state;
    const { total, submitted } = this.getTotalParticipants();
    const districtOptions = (this.state.ListDistrict || []).map(district => ({
      value: district.name,
      label: district.name,
    }));
    const filteredData = (this.state.GetAnalyte || []).filter(entry => {
      const { analyteFilter, schemeFilter, cycleFilter, roundFilter } =
        this.state;

      if (analyteFilter && entry.analyte_id != analyteFilter) return false;
      if (schemeFilter && entry.scheme_name != schemeFilter) return false;
      if (cycleFilter && entry.cycle_no != cycleFilter) return false;
      if (roundFilter && entry.round_id != roundFilter) return false;

      return true;
    });

    const totalParticipants = filteredData.length;
    const participantsWithResults = filteredData.filter(
      lab => lab.result_value !== null && lab.result_value !== undefined
    ).length;
    const pageOptions = {
      sizePerPage: 50,
      totalSize: filteredData.length,
      custom: true,
      page: this.state.currentPage || 1,
      onPageChange: page => {
        this.setState({ currentPage: page });
      },
    };

    const roundColumns = (this.state.selectedSchemeRounds || []).map(
      (round, index) => ({
        dataField: `round_${index + 1}`,
        text: `Round ${index + 1}`,
        sort: true,
        style: { textAlign: "center" },
        formatter: (cell, row) => {
          if (!cell || cell.count === 0) return "NS";
          return (
            <span
              style={{
                color: "blue",
                cursor: "pointer",
                textDecoration: "underline",
              }}
              onClick={() =>
                this.setState({
                  schemeModalOpen: true,
                  modalParticipantName: `Round ${index + 1}`,
                  hoveredSchemeNames: cell.participants || [], // ✅ use participants
                })
              }
            >
              {cell.count}
            </span>
          );
        },
        headerFormatter: column => (
          <div style={{ textAlign: "center" }}>{column.text}</div>
        ),
      })
    );

    // ✅ Step: Conditionally include the "Round" column
    let visibleColumns = [...this.state.feedbackListColumns];

    // Remove result_type column first
    visibleColumns = visibleColumns.filter(
      col => col.dataField !== "result_type"
    );

    // Add it only if Qualitative
    if (this.state.analyteType?.toLowerCase() === "qualitative") {
      visibleColumns.splice(3, 0, {
        dataField: "result_type",
        text: "Result Type",
        sort: true,
        style: { textAlign: "left" },
        formatter: (cell, row) =>
          row.result_value !== null && row.result_value !== undefined
            ? cell || "NS"
            : "NS",
        headerFormatter: (column, colIndex) => (
          <div style={{ textAlign: "center" }}>
            <div>{column.text}</div>
            <div style={{ marginTop: "5px" }}>
              <input
                type="text"
                value={this.state.resulttypeFilter}
                onChange={e => this.handleFilterChange("resulttypeFilter", e)}
                className="form-control"
                style={{
                  textAlign: "center",
                  width: "100px",
                  margin: "auto",
                }}
              />
            </div>
          </div>
        ),
      });
    }

    // Remove or include "Round" column dynamically
    if (this.state.schemeFilter && !this.state.roundFilter) {
      // Scheme selected but no single round selected → show Round column
      if (!visibleColumns.some(col => col.dataField === "round_name")) {
        visibleColumns.push({
          dataField: "round_name",
          text: "Round",
          sort: true,
          style: { textAlign: "left" },
          formatter: cell => (cell ? cell : "NS"),
          headerFormatter: (column, colIndex) => (
            <div style={{ textAlign: "center" }}>
              <div>{column.text}</div>
              <div style={{ marginTop: "5px" }}>
                <input
                  type="text"
                  value={this.state.roundFilter}
                  onChange={e => this.handleFilterChange("roundFilter", e)}
                  className="form-control"
                  style={{
                    textAlign: "center",
                    width: "100px",
                    margin: "auto",
                  }}
                />
              </div>
            </div>
          ),
        });
      }
    } else {
      // If a specific round is selected → remove the Round column
      visibleColumns = visibleColumns.filter(c => c.dataField !== "round_name");
    }
    const allColumns = [...visibleColumns, ...roundColumns];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Analyte Report | NHS NEQAS</title>
          </MetaTags>

          <Container fluid>
            {/* Render Breadcrumbs */}
            <Breadcrumbs title="Labs" breadcrumbItem="Analyte-Value REPORT " />
            <Row className="justify-content-center align-item-center">
              <Col lg="10">
                {" "}
                {/* <p>
                  <strong>Note:</strong> Click on Scheme Number to get detail of
                  each participants payments
                </p> */}
                <Card>
                  <CardBody>
                    <PaginationProvider
                      key={`${this.state.analyteFilter}-${this.state.schemeFilter}-${this.state.cycleFilter}-${this.state.roundFilter}`}
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={this.state.feedbackListColumns}
                      data={this.filterData()}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={allColumns}
                          data={this.filterData()}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              {/* <Modal
                                isOpen={this.state.schemeModalOpen}
                                toggle={this.handleSchemeModalClose}
                              >
                                <ModalHeader
                                  toggle={this.handleSchemeModalClose}
                                >
                                  Scheme Details for{" "}
                                  {this.state.modalParticipantName || "Unknown"}
                                </ModalHeader>
                                <ModalBody>
                                  <table className="table table-bordered">
                                    <thead>
                                      <tr>
                                        <th className="text-start">
                                          Participant Name
                                        </th>
                                        <th className="text-start">District</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(
                                        this.state.hoveredSchemeNames || []
                                      ).map((p, idx) => (
                                        <tr key={idx}>
                                          <td className="text-start">
                                            {p.name}
                                          </td>
                                          <td className="text-start">
                                            {p.district}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </ModalBody>
                              </Modal> */}
                              <Modal
                                isOpen={this.state.participantModalOpen}
                                toggle={() =>
                                  this.setState({ participantModalOpen: false })
                                }
                                size="lg"
                              >
                                <ModalHeader
                                  toggle={() =>
                                    this.setState({
                                      participantModalOpen: false,
                                    })
                                  }
                                >
                                  {this.state.selectedParticipant}
                                </ModalHeader>
                                <ModalBody>
                                  <Table bordered responsive>
                                    <thead>
                                      <tr>
                                        {Object.keys(
                                          this.state.participantRows?.[0] || {}
                                        ).map(key => (
                                          <th key={key} className="text-center">
                                            {key}
                                          </th>
                                        ))}
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.participantRows?.map(
                                        (row, i) => (
                                          <tr key={i}>
                                            {Object.values(row).map(
                                              (val, idx) => (
                                                <td
                                                  key={idx}
                                                  className="text-center"
                                                >
                                                  {val}
                                                </td>
                                              )
                                            )}
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </ModalBody>
                              </Modal>

                              <Row className="mb-3">
                                <Col md={4}>
                                  <Label for="analyteFilter">Analyte</Label>
                                  <Select
                                    id="analyteFilter"
                                    options={[
                                      { value: "All", label: "All Analytes" },
                                      ...(this.state.analytes || []).map(a => ({
                                        value: a.id,
                                        label: a.name,
                                      })),
                                    ]}
                                    value={
                                      this.state.analyteFilter
                                        ? {
                                            value: this.state.analyteFilter,
                                            label:
                                              (this.state.analytes || []).find(
                                                a =>
                                                  a.id ===
                                                  this.state.analyteFilter
                                              )?.name || "",
                                          }
                                        : null
                                    }
                                    onChange={selected => {
                                      const selectedAnalyteId =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;
                                      this.handleFilterChange("analyteFilter", {
                                        target: { value: selectedAnalyteId },
                                      });

                                      this.setState({
                                        schemeFilter: "",
                                        cycleFilter: "",
                                        roundFilter: "",
                                        filteredSchemes: [],
                                        filteredCycles: [],
                                        filteredRounds: [],
                                        GetAnalyte: [],
                                      });

                                      if (selectedAnalyteId) {
                                        const user_id = this.state.user_id;
                                        this.props.onGetAnalyteReport2(
                                          selectedAnalyteId,
                                          user_id
                                        );
                                      }
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="schemeFilter">Scheme</Label>
                                  <Select
                                    id="schemeFilter"
                                    options={[
                                      { value: "All", label: "All Schemes" },
                                      ...(this.state.filteredSchemes || []).map(
                                        s => ({ value: s, label: s })
                                      ),
                                    ]}
                                    value={
                                      this.state.schemeFilter
                                        ? {
                                            value: this.state.schemeFilter,
                                            label: this.state.schemeFilter,
                                          }
                                        : null
                                    }
                                    onChange={selected => {
                                      const schemeName =
                                        selected?.value === "All"
                                          ? ""
                                          : selected?.value;
                                      this.handleFilterChange("schemeFilter", {
                                        target: { value: schemeName },
                                      });

                                      // Find selected scheme
                                      const selectedScheme = (
                                        this.state.reportSchemes || []
                                      ).find(s => s.scheme_name === schemeName);

                                      // Extract cycles safely
                                      const cycles = Array.isArray(
                                        selectedScheme?.cycles
                                      )
                                        ? selectedScheme.cycles.map(
                                            c => c.cycle_no
                                          )
                                        : [];

                                      this.setState({
                                        cycleFilter: "",
                                        roundFilter: "",
                                        filteredCycles: [...new Set(cycles)],
                                        filteredRounds: [],
                                      });
                                    }}
                                    isClearable
                                  />
                                </Col>

                                <Col md={4}>
                                  <Label for="cycleFilter">Cycle</Label>
                                  <Select
                                    id="cycleFilter"
                                    options={[
                                      { value: "All", label: "All Cycles" },
                                      ...(this.state.filteredCycles || []).map(
                                        cycle => ({
                                          value: cycle,
                                          label: cycle,
                                        })
                                      ),
                                    ]}
                                    value={
                                      this.state.cycleFilter
                                        ? {
                                            value: this.state.cycleFilter,
                                            label: this.state.cycleFilter,
                                          }
                                        : null
                                    }
                                    onChange={this.handleCycleChange}
                                    isClearable
                                  />
                                </Col>
                                <Col md={4}>
                                  <Label for="roundFilter">Round</Label>
                                  <Select
                                    id="roundFilter"
                                    options={[
                                      { value: "All", label: "All Rounds" },
                                      ...(Array.isArray(
                                        this.state.filteredRounds
                                      )
                                        ? this.state.filteredRounds.map(r => ({
                                            value: String(r.round_id),
                                            label: r.round_name,
                                          }))
                                        : []),
                                    ]}
                                    value={
                                      this.state.roundFilter
                                        ? {
                                            value: String(
                                              this.state.roundFilter
                                            ),
                                            label:
                                              (
                                                this.state.filteredRounds || []
                                              ).find(
                                                rr =>
                                                  String(rr.round_id) ===
                                                  String(this.state.roundFilter)
                                              )?.round_name || "",
                                          }
                                        : null
                                    }
                                    onChange={this.handleRoundChange}
                                    isClearable
                                  />
                                </Col>

                                <Col md={6} className="mt-4">
                                  <h6>
                                    Total Participants:{" "}
                                    <span className="text-primary">
                                      {total}
                                    </span>
                                    &nbsp; and &nbsp; Result Submitted
                                    Participants:{" "}
                                    <span className="text-primary">
                                      {submitted}
                                    </span>
                                  </h6>
                                </Col>

                                <Row></Row>
                              </Row>

                              <Row className="mb-4">
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-condensed table-hover"
                                      }
                                      bordered={false}
                                      striped={true}
                                      headerWrapperClasses={
                                        "table-header-sky-blue"
                                      }
                                      responsive
                                      ref={this.node}
                                      filter={filterFactory()}
                                    />
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

AnalyteReport2.propTypes = {
  GetAnalyte: PropTypes.array,
  AnalyteReport2: PropTypes.object, // ✅ matches API
  onGetAnalyteReport2: PropTypes.func,
  AnalyteList: PropTypes.array,
  onGetAnalyte: PropTypes.func,
  match: PropTypes.object,
};

const mapStateToProps = state => {
  return {
    // Make sure ListUnit actually contains an array of analytes
    AnalyteList:
      state.ListUnit?.ListUnit?.data || state.ListUnit?.ListUnit || [],
    AnalyteReport2: state.AddPayment?.GetAnalyte || {}, // API response { analyte, schemes }
  };
};

const mapDispatchToProps = dispatch => ({
  onGetAnalyteReport2: id => dispatch(getanalytereport2(id)),
  onGetAnalyte: id => dispatch(getAnalytelist(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AnalyteReport2);
